// @flow
import * as React from 'react';
import { StyleSheet } from 'react-native';
import { Separator } from 'trpc-react-native-ui';
import I18n from '../../../lib/i18n';
import config from '../../../config';
import { Frame } from '../../common';
import PlanRenewal from '../PlanRenewal';
import { ShortPlan } from '../ShortPlan';

const PlanFrame = (props: Props) => {
  const hasData = props.isLineOFF || props.subscription?.plan;
  if (!hasData && !props.isFetching) return null;

  return (
    <Frame
      title={I18n.t('Dashboard.Plan.title')}
      isLoadingForToggling={props.isLoadingForToggling}
      onToggleFolded={
        !props.isSubscriptionSuspended && (!props.isLineOFF || config.canTurnBackOn) && props.toggleFolded
      }
      toggleTitle={props.isLineOFF ? I18n.t('Dashboard.Plan.lineOffActionTitle') : I18n.t('Dashboard.Plan.actionTitle')}
      folded
      isLoading={!hasData && props.isFetching}
      style={[styles.container, props.style]}
      headerTestID="dashboard-yourPlan-button"
    >
      <Frame.Content style={styles.frameContent} rtl>
        <ShortPlan subscription={props.subscription} />
        <Separator direction="vertical" />
        <PlanRenewal isEditing={!props.folded} />
      </Frame.Content>
    </Frame>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 8,
    paddingBottom: 20,
    paddingHorizontal: 16,
  },
  frameContent: {
    flexDirection: 'row',
  },
});

type Props = {
  toggleFolded?: Function,
  folded?: boolean,
  subscription?: Object,
  isLoadingForToggling?: boolean,
  isFetching: boolean,
  style?: any,
  isLineOFF: boolean,
  isSubscriptionSuspended: boolean,
};

export default PlanFrame;
